(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if(!window.kpCardExperience){
    window.kpCardExperience=true;
    document.addEventListener('click',function(event){
      var button=event.target.closest('[data-card] .vdot');
      if(!button)return;
      var card=button.closest('[data-card]');
      var title=card.querySelector('[data-card-title]');
      var media=card.querySelector('[data-card-media]');
      if(button.dataset.variantUrl){
        if(title)title.href=button.dataset.variantUrl;
        if(media)media.href=button.dataset.variantUrl;
        var priceLink=card.querySelector('[data-card-price-link]');
        if(priceLink)priceLink.href=button.dataset.variantUrl;
      }
      card.querySelectorAll('.vdot').forEach(function(dot){dot.setAttribute('aria-pressed',String(dot===button))});
      var image=card.querySelector('.card__image');
      if(image&&button.dataset.img){
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src=button.dataset.img;
        if(button.dataset.imgWidth)image.width=Number(button.dataset.imgWidth);
        if(button.dataset.imgHeight)image.height=Number(button.dataset.imgHeight);
        if(button.dataset.imgRatio&&media){
          var ratio=Number(button.dataset.imgRatio);
          media.style.setProperty('--card-image-ratio',String(ratio));
          media.style.setProperty('--card-frame-ratio',String(Math.max(.8,Math.min(1,ratio))));
        }
        if(button.dataset.imgPosition&&media)media.style.setProperty('--card-image-position',button.dataset.imgPosition);
      }
      var hint=card.querySelector('[data-variant-hint]');
      if(hint){hint.textContent=button.dataset.label||'';hint.setAttribute('data-active','')}
      var price=card.querySelector('.price');
      if(card.dataset.cardQuote==='true'){
        if(price){price.textContent=card.dataset.quoteLabel;price.className='price price--quote'}
        return;
      }
      var availability=card.querySelector('.card__availability');
      if(availability)availability.hidden=button.dataset.available==='true';
      if(price&&button.dataset.price){
        price.textContent=button.dataset.price;
        price.classList.toggle('price--sale',Boolean(button.dataset.compare));
        if(button.dataset.compare){var previous=document.createElement('span');previous.className='was';previous.textContent=button.dataset.compare;price.appendChild(previous)}
        var priceLabel=card.querySelector('[data-card-price-label]');
        if(priceLabel)priceLabel.textContent=button.dataset.compare?'Oferta':'Precio';
      }
      var fixedOffer=button.dataset.fixed==='true';
      var fixedBadge=card.querySelector('.promo-sticker--fixed');
      if(fixedBadge){fixedBadge.hidden=!fixedOffer;fixedBadge.style.display=fixedOffer?'':'none'}
      var badge=card.querySelector('.promo-sticker--percent');
      if(badge){
        var showPercent=Boolean(button.dataset.discount)&&!fixedOffer;
        badge.hidden=!showPercent;
        badge.style.display=showPercent?'':'none';
        var label=badge.querySelector('.promo-sticker__label');
        if(label)label.textContent=button.dataset.discount?'-'+button.dataset.discount+'%':'';
        badge.setAttribute('aria-label',button.dataset.discount?card.dataset.discountLabel.replace('__PERCENT__',button.dataset.discount):'');
      }
    });
    document.addEventListener('pointermove',function(event){
      if(event.pointerType==='touch'||!window.matchMedia('(hover:hover) and (pointer:fine)').matches||window.matchMedia('(prefers-reduced-motion:reduce)').matches)return;
      var media=event.target.closest('.card--editorial [data-card-media]');
      if(!media)return;
      var rect=media.getBoundingClientRect();
      if(!rect.width||!rect.height)return;
      var x=Math.max(-3,Math.min(3,((event.clientX-rect.left)/rect.width-.5)*6));
      var y=Math.max(-3,Math.min(3,((event.clientY-rect.top)/rect.height-.5)*6));
      media.style.setProperty('--card-shift-x',x.toFixed(2)+'px');
      media.style.setProperty('--card-shift-y',y.toFixed(2)+'px');
    },{passive:true});
    document.addEventListener('pointerout',function(event){
      var media=event.target.closest('.card--editorial [data-card-media]');
      if(!media||(event.relatedTarget&&media.contains(event.relatedTarget)))return;
      media.style.removeProperty('--card-shift-x');
      media.style.removeProperty('--card-shift-y');
    },{passive:true});
  }
  } catch(e) { console.error(e); }
})();

})();
